import PasswordSet from './PasswordSet'

export default function install(Vue) {
  Vue.component('auth-password-set', PasswordSet)
}
